export default "__VITE_ASSET__SiappADH__"